import { render, staticRenderFns } from "./Asset-Documents.vue?vue&type=template&id=b00e6766&"
import script from "./Asset-Documents.vue?vue&type=script&lang=ts&"
export * from "./Asset-Documents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports